export const getVideoURL = (media) => {
  const { id, type, originalValue } = media ?? {};
  if (type === 'vimeo' && id) {
    return `https://vimeo.com/${id}`;
  }

  return originalValue;
};
